import { Menu } from "@headlessui/react";

export const VendorProductsActionMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handlePublishVendorProducts
}) => {
    return (
        <>
        <Menu as="div" className="relative text-left">
									<div>
										<Menu.Button
											onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
											className="p-2 bg-slate-300 hover:bg-slate-400 text-gray-800 hover:text-gray-900 rounded cursor-pointer"
											title="More Actions..."
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="currentColor"
												viewBox="0 0 24 24"
												width="24"
												height="22"
											>
												<circle cx="12" cy="5" r="2" />
												<circle cx="12" cy="12" r="2" />
												<circle cx="12" cy="19" r="2" />
											</svg>
										</Menu.Button>
									</div>
									{anchorShipmentEl && (
										<Menu.Items className="absolute z-20 ms-3 my-1 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }}>
											<div className="px-1 py-1">
												{/* Vendor Products Related Actions Section */}
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handlePublishVendorProducts();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-200' : ''
																} group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
														// title="Publish Products"
														>
															<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="28" height="24">
																<path d="M6 18a6 6 0 0 1-6-6 6 6 0 0 1 6-6c.3 0 .6.03.9.08a5.992 5.992 0 0 1 11.2 0C18.4 6.03 18.7 6 19 6a6 6 0 0 1 6 6 6 6 0 0 1-6 6h-2z" fill="none" stroke="currentColor" stroke-width="2" />
																<path d="M14 10l4 4-4 4-4-4 4-4z" stroke="currentColor" stroke-width="2" />
																<path d="M16 16l-4 4-4-4" stroke="currentColor" stroke-width="2" />
															</svg>
															<span className='mx-3'>Publish Products</span>
														</button>
													)}
												</Menu.Item>
											</div>
										</Menu.Items>
									)}
								</Menu>
        </>
    )
}